const getPageSize: { [x: string]: number } = {
  large: 4,
  medium: 3,
  small: 2,
  xlarge: 5,
  xsmall: 1
}

export const getPageSizeByKey = (key: string): number => {
  return getPageSize[key]
}

export const getKeyByPageSize = (value: number): string | undefined => {
  return Object.keys(getPageSize).find(key => getPageSize[key] === value)
}
